import React, { forwardRef, useId } from "react";
import * as RadixSwitch from "@radix-ui/react-switch";
import "./Switch.css";

export const Switch = forwardRef(function Switch(
  { label, hint, id: idProp, className = "", ...props },
  ref
) {
  const reactId = useId();
  const id = idProp || reactId;
  return (
    <label htmlFor={id} className={`ui-switch-row ${className}`}>
      {(label || hint) && (
        <span className="ui-switch-text">
          {label && <span className="ui-switch-label">{label}</span>}
          {hint && <span className="ui-switch-hint">{hint}</span>}
        </span>
      )}
      <RadixSwitch.Root ref={ref} id={id} className="ui-switch" {...props}>
        <RadixSwitch.Thumb className="ui-switch-thumb" />
      </RadixSwitch.Root>
    </label>
  );
});
